import { Box, Text, TextButton, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { InfoCircle } from '@wix/wix-ui-icons-common';
import React, { FC, useState } from 'react';

import { SectionComponentProps } from '../types';
import { requestSuccessManagerDataHooks } from './RequestSuccessManager.dataHooks';
import { RequestSuccessManagerIconSvg } from './RequestSuccessManagerIconSvg';

export const RequestSuccessManager: FC<SectionComponentProps> = () => {
  const { t } = useTranslation();
  // TODO: Get requestedAccess value
  const [isRequestSent, setIsRequestSent] = useState(false);

  return (
    <Box width="100%" direction="vertical" gap={2} padding="18px">
      <Box gap={2} verticalAlign="middle">
        <Box>
          <RequestSuccessManagerIconSvg />
        </Box>
        <Box direction="vertical" gap={1}>
          <Text
            size="small"
            dataHook={requestSuccessManagerDataHooks.description()}
          >
            {t('home_request_success_manager_description')}
          </Text>
          <Box>
            <Tooltip
              content={t('home_request_success_manager_info')}
              size="small"
              placement="top"
              disabled={!isRequestSent}
            >
              <Box gap={1} alignContent="center">
                <TextButton
                  // TODO: Add link - https://app.asana.com/0/0/1205246699868135/f
                  disabled={isRequestSent}
                  size="small"
                  weight="normal"
                  dataHook={requestSuccessManagerDataHooks.link()}
                  suffixIcon={
                    isRequestSent ? (
                      <Box height={24} width={24}>
                        <InfoCircle size={24} />
                      </Box>
                    ) : undefined
                  }
                >
                  {isRequestSent
                    ? t('home_request_success_manager_request_sent')
                    : t('home_request_success_manager_request_access')}
                </TextButton>
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
